import { render, staticRenderFns } from "./user_left_menu.vue?vue&type=template&id=1900ab13&scoped=true"
import script from "./user_left_menu.vue?vue&type=script&lang=js"
export * from "./user_left_menu.vue?vue&type=script&lang=js"
import style0 from "./user_left_menu.css?vue&type=style&index=0&id=1900ab13&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900ab13",
  null
  
)

export default component.exports